const maskedUserName = (name) => {
    if (name) {
        if (name !== '---') {
            return name[0] + '****' + name[name.length - 1];
        }
    }
    return name;
};

export default maskedUserName;